import { isValidCustomsCode } from '@/inventory/pages/InventoryPage/EditItemInfoDrawer/helpers'

import { countryConfigs, disabledHelperText, europeanUnionCustomsConfig } from './constants'

const getEnabledHelperText = extraDigits => {
  if (extraDigits === 0)
    return 'Este mercado utiliza directamente el código HS estándar de 6 dígitos, no se requieren dígitos adicionales.'

  return `Introduce sólo los ${extraDigits} últimos dígitos; los 6 primeros se completan automáticamente a partir de tu código HS.`
}

const getValidationError = extraDigits => {
  if (extraDigits === 0) return null
  return `El código debe tener ${extraDigits} dígitos.`
}

const createCustomsCodeField = (config, hsCode, key) => {
  const { label, extraDigits } = config
  const isNoDigits = extraDigits === 0

  const validate = value => {
    if (isNoDigits) return null
    if (!value) return null
    if (!isValidCustomsCode(value, undefined, extraDigits)) return getValidationError(extraDigits)
    return null
  }

  const getHelperText = (value, touched) => {
    if (!hsCode) return disabledHelperText
    if (touched) {
      const error = validate(value)
      if (error) return error
    }
    return getEnabledHelperText(extraDigits)
  }

  const getValue = value => {
    if (isNoDigits) return ''
    if (!value) return value
    if (hsCode && value.startsWith(hsCode)) return value.slice(hsCode.length)
    if (value.length <= extraDigits) return value
    return value
  }

  const formatOnChange = value => {
    if (isNoDigits) return hsCode || value
    if (!value) return ''

    return hsCode ? `${hsCode}${value}` : value
  }

  return {
    key,
    label,
    type: 'text',
    maxLength: isNoDigits ? 0 : extraDigits,
    startAdornment: hsCode || undefined,
    showCounter: !!hsCode && !isNoDigits,
    disabled: !hsCode || isNoDigits,
    validate,
    isMissing: value => !!hsCode && !isNoDigits && !value,
    warning: 'La aduana no puede clasificar este producto. Los envíos a {{country}} pueden quedar retenidos.',
    getHelperText,
    getValue,
    formatOnChange,
  }
}

const buildCountryExtraFields = () => {
  const result = {}

  Object.entries(countryConfigs).forEach(([countryCode, config]) => {
    result[countryCode] = hsCode => {
      const fields = [createCustomsCodeField(config, hsCode, 'country_customs_code')]

      if (countryCode === 'US') {
        fields.push({
          key: 'mid_code',
          label: 'Código MID del fabricante',
          type: 'text',
          isMissing: value => !value,
          warning: 'Lo exige la aduana de EE. UU. Los envíos a EE. UU. pueden quedar retenidos.',
        })
      }

      return fields
    }
  })

  return result
}

const countryExtraFields = buildCountryExtraFields()

export const getCountryExtraFields = (countryCode, hsCode) => {
  const getFields = countryExtraFields[countryCode]

  if (!getFields) return null

  return getFields(hsCode)
}

export const getEuropeanUnionExtraFields = hsCode => {
  return [createCustomsCodeField(europeanUnionCustomsConfig, hsCode, 'taric_code')]
}
